<template>
  <div>
    <el-dialog :title="title" :visible.sync="visible" :width="width" append-to-body @close="onClose">
      <w-table :columns="columns" :table-data="tableData">
        <slot></slot>
        <span slot="sampleInfo" slot-scope="{text,record}">
          <span style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(record)">查看样本<i class="viewIcon"
                                                                                                  v-html="viewDetailIcon"></i></span>
        </span>
      </w-table>
    </el-dialog>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
  </div>

</template>

<script>
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";
import {viewDetailIcon} from "@/utils/iconUtils";

export default {
  name: "ApprovalRecordDialog",
  components: {SampleInfoDialog},
  props: {
    showDialog: {type: Boolean, default: false},
    title: {type: String, default: '释放记录'},
    width: {type: String, default: '600px'},
    columns: {type: Array, default: () => []},
    tableData: {type: Array, default: () => []},
    projectId: {type: String, default: ''},
  },
  data() {
    return {
      sampleInfoDialog: false,
      selectDetail: {},
      viewDetailIcon: viewDetailIcon
    }
  },
  computed: {
    visible: {
      get() { return this.showDialog },
      set(val) { this.$emit('update:showDialog', val) }
    }
  },

  methods: {
    onClose() {
      this.$emit('close')
    },
    lookSampleInfo(row) {
      this.selectDetail = {
        projectId: this.projectId,
        platform: 'LUOCE',
        isNeedFilterSample: row.hasSampleNames,
        sampleNameList: row.sampleNames ? row.sampleNames : []
      }
      this.sampleInfoDialog = true
    },
  }
}
</script>
